<template>
  <div
    class="ajax-loader"
    :style="{
      aspectRatio: '1/1',
      width: `${props.width}px`,
      '--border-width': `${borderWidth}px`,
    }"
  >
    <span class="ui active centered inline loader" style="z-index: 100"></span>
  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "LoaderAnimatedIcon",
});

const props = withDefaults(
  defineProps<{
    width?: number;
    borderWidth?: number;
  }>(),
  {
    width: 50,
    borderWidth: 2,
  }
);
</script>

<style scoped lang="scss">
.ajax-loader {
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 0;

  :deep(span),
  :deep(span::before),
  :deep(span::after) {
    width: 100%;
    height: 100%;
    margin: 0 !important;
    border-width: var(--border-width, 2px);
    left: 0;
  }

  :deep(span::after) {
    animation-duration: 1.1s !important;
  }
}
</style>
